var _path, _rect, _path2, _rect2, _path3, _rect3, _rect4, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 522,
    viewBox: "0 0 435 522",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.425 0L435 115H38V0H322.425Z",
    fill: "#FAFAFD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 115,
    width: 397,
    height: 407,
    fill: "#FAFAFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M322.5 115H435L322.5 0V115Z",
    fill: "#DEE2E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 115,
    width: 97,
    height: 16,
    fill: "#E9ECEF",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.323 123C135.027 172.113 170.627 224.708 214.5 279.291C275.856 355.627 338.19 411.736 396 452.359V459.791C396 477.464 381.673 491.791 364 491.791H110C92.3269 491.791 78 477.464 78 459.791V154.791C78 138.361 90.3819 124.824 106.323 123Z",
    fill: "#E9ECEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 278,
    height: 111,
    fill: "#D63384"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 131,
    width: 218,
    height: 31,
    fill: "#E9ECEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_701_379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.6932 99H36.6932L53.0795 52.4545H63.4886L79.8977 99H70.8977L58.4659 62H58.1023L45.6932 99ZM45.9886 80.75H70.5341V87.5227H45.9886V80.75ZM115.369 52.4545H123.801V82.8636C123.801 86.197 123.013 89.1288 121.438 91.6591C119.877 94.1894 117.68 96.1667 114.847 97.5909C112.013 99 108.703 99.7045 104.915 99.7045C101.112 99.7045 97.7936 99 94.9602 97.5909C92.1269 96.1667 89.9299 94.1894 88.3693 91.6591C86.8087 89.1288 86.0284 86.197 86.0284 82.8636V52.4545H94.4602V82.1591C94.4602 84.0985 94.8845 85.8258 95.733 87.3409C96.5966 88.8561 97.8087 90.0455 99.3693 90.9091C100.93 91.7576 102.778 92.1818 104.915 92.1818C107.051 92.1818 108.9 91.7576 110.46 90.9091C112.036 90.0455 113.248 88.8561 114.097 87.3409C114.945 85.8258 115.369 84.0985 115.369 82.1591V52.4545ZM148.739 99H132.966V52.4545H149.057C153.678 52.4545 157.648 53.3864 160.966 55.25C164.299 57.0985 166.86 59.7576 168.648 63.2273C170.436 66.697 171.33 70.8485 171.33 75.6818C171.33 80.5303 170.428 84.697 168.625 88.1818C166.837 91.6667 164.254 94.3409 160.875 96.2045C157.511 98.0682 153.466 99 148.739 99ZM141.398 91.7045H148.33C151.572 91.7045 154.277 91.1136 156.443 89.9318C158.61 88.7348 160.239 86.9545 161.33 84.5909C162.42 82.2121 162.966 79.2424 162.966 75.6818C162.966 72.1212 162.42 69.1667 161.33 66.8182C160.239 64.4545 158.625 62.6894 156.489 61.5227C154.367 60.3409 151.731 59.75 148.58 59.75H141.398V91.7045ZM187.773 52.4545V99H179.341V52.4545H187.773ZM238.494 75.7273C238.494 80.7424 237.555 85.0379 235.676 88.6136C233.813 92.1742 231.267 94.9015 228.04 96.7955C224.828 98.6894 221.184 99.6364 217.108 99.6364C213.032 99.6364 209.381 98.6894 206.153 96.7955C202.941 94.8864 200.396 92.1515 198.517 88.5909C196.653 85.0152 195.722 80.7273 195.722 75.7273C195.722 70.7121 196.653 66.4242 198.517 62.8636C200.396 59.2879 202.941 56.553 206.153 54.6591C209.381 52.7651 213.032 51.8182 217.108 51.8182C221.184 51.8182 224.828 52.7651 228.04 54.6591C231.267 56.553 233.813 59.2879 235.676 62.8636C237.555 66.4242 238.494 70.7121 238.494 75.7273ZM230.017 75.7273C230.017 72.197 229.464 69.2197 228.358 66.7955C227.267 64.3561 225.752 62.5152 223.812 61.2727C221.873 60.0152 219.638 59.3864 217.108 59.3864C214.578 59.3864 212.343 60.0152 210.403 61.2727C208.464 62.5152 206.941 64.3561 205.835 66.7955C204.744 69.2197 204.199 72.197 204.199 75.7273C204.199 79.2576 204.744 82.2424 205.835 84.6818C206.941 87.1061 208.464 88.947 210.403 90.2045C212.343 91.447 214.578 92.0682 217.108 92.0682C219.638 92.0682 221.873 91.447 223.812 90.2045C225.752 88.947 227.267 87.1061 228.358 84.6818C229.464 82.2424 230.017 79.2576 230.017 75.7273Z",
    fill: "#FAFAFD"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_701_379)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.833 352.773C315.408 351.796 320.677 351.959 325.295 353.037V244.496L210.447 277.476V403.513C210.508 404.205 210.549 404.917 210.549 405.609V405.629C210.549 422.597 192.747 439.443 170.775 443.247C148.822 447.031 131 436.35 131 419.362C131 402.394 148.822 385.549 170.775 381.764C179.035 380.34 186.725 380.971 193.093 383.209V228.058H194.049L342.67 194V368.805C342.934 370.086 343.077 371.389 343.077 372.691C343.077 372.691 343.077 372.691 343.077 372.711C343.077 386.891 328.184 400.97 309.853 404.124C291.502 407.298 276.63 398.366 276.63 384.186C276.61 370.005 291.482 355.926 309.833 352.773Z",
    fill: "#D63384"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_701_379",
    x: 24.6931,
    y: 51.8184,
    width: 217.801,
    height: 63.8862,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_701_379"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_701_379",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_701_379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 212.056,
    height: 250,
    fill: "white",
    transform: "translate(131 194)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.84b03ab52933701d0fab6966c86e24cd.svg";
export { ForwardRef as ReactComponent };